import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Private from "./Private";
import Public from "./Public";

import Home from "../pages/home";
import Customers from "../pages/customers";
// import NewCustomer from "../pages/customers/NewCustomer";
import Settings from "../pages/Settings";
import SignIn from "../pages/Auth/Signin";
import Categories from "../pages/categories";
import Ads from "../pages/ads";
import AdDetails from "../pages/ads/AdDetails";
import Bookings from "../pages/Bookings";
import BookingDetails from "../pages/Bookings/BookingDetails";
import Notifications from "../pages/Notification";

const Routing = () => {
  return (
    <BrowserRouter>
      <ToastContainer position="top-center" />
      <Routes>
        <Route
          path="/"
          element={
            <Public>
              <SignIn />
            </Public>
          }
        />
        <Route
          path="/dashboard/home"
          element={
            <Private>
              <Home />
            </Private>
          }
        />



        <Route
          path="/dashboard/categories"
          element={
            <Private>
              <Categories />
            </Private>
          }
        />
        <Route
          path="/dashboard/customers"
          element={
            <Private>
              <Customers />
            </Private>
          }
        />
        <Route
          path="/dashboard/customers"
          element={
            <Private>
              <Customers />
            </Private>
          }
        />
        <Route
          path="/dashboard/ads"
          element={
            <Private>
              <Ads />
            </Private>
          }
        />

        <Route path="/dashboard/ad-details/:id" element={<Private><AdDetails /></Private>} />
        <Route path="/dashboard/bookings" element={<Private><Bookings /></Private>} />
        <Route path="/dashboard/booking-details/:id" element={<Private><BookingDetails /></Private>} />
        <Route path="/dashboard/notifications" element={<Private><Notifications /></Private>} />



        {/* <Route
          path="/dashboard/add-customer"
          element={
            <Private>
              <NewCustomer />
            </Private>
          }
        />
      */}
        <Route
          path="/dashboard/settings"
          element={
            <Private>
              <Settings />
            </Private>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Routing;



// import React, { useEffect, useState } from "react";
// import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import Private from "./Private";
// import Public from "./Public";

// import { useSelector } from "react-redux";
// import Home from "../pages/home";
// import Vehicles from "../pages/vehicles";
// import AddNewVehicle from "../pages/vehicles/AddNewVehicle";
// import VehicleDetails from "../pages/vehicles/VehicleDetails";
// import Customers from "../pages/customers";
// import NewCustomer from "../pages/customers/NewCustomer";
// import RentContract from "../pages/rentcontract/AddNewContract";
// import Contracts from "../pages/rentcontract";
// import Settings from "../pages/Settings";
// import Pledge from "../pages/customers/CreatePledge";
// import SignIn from "../pages/Auth/Signin";



// const Routing = () => {
//   const { adminToken } = useSelector((state) => state.authReducer);

//   const adminDataString = localStorage.getItem("admin");
//   let isAdmin = null;
//   if (adminDataString) {
//     try {
//       isAdmin = JSON.parse(adminDataString);
//     } catch (error) {
//       console.error("Error parsing admin data:", error);
//     }
//   }

//   useEffect(() => {
//     if (!adminToken && window.location.pathname !== "/") {
//       window.location.pathname = "/";
//     }
//     if (!isAdmin && window.location.pathname !== "/") {
//       window.location.pathname = "/";
//     }
//   }, []);

//   return (
//     <BrowserRouter>
//       <ToastContainer position="top-center" />

//       <Routes>
//         <Route
//           path="/"
//           element={
//             <Public>
//               <SignIn />
//             </Public>
//           }
//         />
//         <Route path="auth">
//           <Route
//             path="login"
//             element={
//               <Public>
//                 <SignIn />
//               </Public>
//             }
//           />
//         </Route>

//         <Route path="dashboard">
//           <Route
//             path="home"
//             element={
//               <Private>
//                 <Home />
//               </Private>
//             }
//           />
//           <Route
//             path="/dashboard/add-contract"
//             element={
//               <Private>
//                 <RentContract />
//               </Private>
//             }
//           />
//           <Route
//             path="/dashboard/contracts"
//             element={
//               <Private>
//                 <Contracts />
//               </Private>
//             }
//           />
//           <Route
//             path="vehicles"
//             element={
//               <Private>
//                 <Vehicles />
//               </Private>
//             }
//           />
//           <Route
//             path="add-vehicle"
//             element={
//               <Private>
//                 <AddNewVehicle />
//               </Private>
//             }
//           />
//           <Route
//             path="vehicle-details/:id"
//             element={
//               <Private>
//                 <VehicleDetails />
//               </Private>
//             }
//           />

//           <Route
//             path="customers"
//             element={
//               <Private>
//                 <Customers />
//               </Private>
//             }
//           />
//           <Route
//             path="add-customer"
//             element={
//               <Private>
//                 <NewCustomer />
//               </Private>
//             }
//           />
//           <Route
//             path="/dashboard/pledge"
//             element={
//               <Private>
//                 <Pledge />
//               </Private>
//             }
//           />
//           <Route
//             path="/dashboard/settings"
//             element={
//               <Private>
//                 <Settings />
//               </Private>
//             }
//           />
//         </Route>
//       </Routes>
//     </BrowserRouter>
//   );
// };

// export default Routing;
